import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import TeamManagement from "@/pages/TeamManagement";
export const Route = createFileRoute("/team")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><TeamManagement /></ProtectedRoute>) });
